import {NavController, AlertController} from 'ionic-angular';
import {Component} from '@angular/core';
import {MapService} from './../../../../services/map';
import {BackendModule} from './../../../../modules/backend.module';
import {SessionService} from './../../../../services/session';
import {AuthService} from './../../../../services/auth';
import {LocationsService} from '../../../../services/locations';

@Component({
  selector: 'page-account',
  templateUrl: 'account.html'
})
export class AccountPage {
  constructor(
    public sessionService: SessionService,
    public alertCtrl: AlertController,
    public backendModule: BackendModule,
    public navCtrl: NavController,
    public authService: AuthService,
    public mapService: MapService,
    public locationsService: LocationsService
  ) {
  }

  changeInfo(form) {
    let phone = this.sessionService.user.profile.emergency_phone_number;
    if (phone !== this.locationsService.translate('MaxPhoneLength')) {
      this.alertCtrl.create({
        title: `Por favor ingresa un número telefónico de ${this.locationsService.translate(
          'MaxPhoneLength'
        )} dígitos`,
        cssClass: 'red-text-alert',
        buttons: [
          {
            text: 'Regresar',
            role: 'cancel'
          }
        ]
      }).present();
      return;
    }

    this.backendModule.postAPI(
      `users/${this.sessionService.user.id}/create_profile`,
      {profile: this.sessionService.user.profile}
    ).subscribe(
      (data: any) => {
        this.sessionService.save();
        this.navCtrl.pop();
        let alert = this.alertCtrl.create({
          title: 'Éxito',
          subTitle: 'Sus datos han sido actualizados',
          buttons: ['Ok']
        });
        alert.present();
      },
      err => {
        this.sessionService.reportError('accountPage', 'changeInfo()', err);
        let alert = this.alertCtrl.create({
          title: 'Error',
          subTitle: JSON.stringify(err),
          buttons: ['Ok']
        });
        alert.present();
      }
    );
  }

  ionViewDidLoad() {
    window['page'] = 'AccountPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/account/account.ts